import type { Theme } from '@mui/material';

type ThemeTokens = Theme['palette']['tokens'];
type ThemeMode = Theme['palette']['mode'];

/**
 * Elevated content surface for the AI experience (composer, cards, chips, tiles, dropdown
 * panels): white on the light-grey canvas in light mode, the elevated neutral token in dark
 * mode. Centralized so these surfaces can't drift apart across AI components.
 */
export const getAISurface = (tokens: ThemeTokens, mode: ThemeMode) =>
  mode === 'light' ? tokens.background.basic.white : tokens.background.neutral.raised[6];

/**
 * Page/header canvas for the AI experience: a shade darker than the default neutral canvas in
 * light mode (so the white surfaces read clearly); the standard canvas in dark mode.
 */
export const getAICanvas = (tokens: ThemeTokens, mode: ThemeMode) =>
  mode === 'light' ? tokens.background.neutral.mid[4] : tokens.background.neutral.canvas.base;
